import React, { useState } from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material'
import { rejectProspect } from 'src/supportPortal/services/patientProspectsApi'
import { toast } from 'react-toastify'

/**
 * Soft reject (per D3 in the plan) — marks the RoleAssignment for
 * ROLE_PATIENT_PROSPECT as REVOKED, marks the prospect record CLOSED,
 * moves the linked CareIntakeCase to DROPPED. The User retains the
 * role itself so /care/status can still surface a softer-copy variant.
 */
export default function RejectProspectDialog({ open, prospect, onClose, onRejected }) {
  const [reason, setReason] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')

  const handleSubmit = async () => {
    setError('')
    if (!prospect?.userId) {
      setError('Missing userId on this prospect.')
      return
    }
    setBusy(true)
    try {
      const res = await rejectProspect(prospect.userId, { reason: reason.trim() || null })
      if (res?.status >= 200 && res?.status < 300) {
        toast.success('Prospect closed.')
        onRejected?.(res.data)
        onClose?.()
      } else {
        const msg = res?.response?.data?.message || res?.data?.message || 'Reject failed.'
        setError(msg)
      }
    } catch (e) {
      setError(e?.message || 'Reject failed.')
    } finally {
      setBusy(false)
    }
  }

  return (
    <Dialog open={open} onClose={busy ? undefined : onClose} fullWidth maxWidth="sm">
      <DialogTitle>Close this prospect</DialogTitle>
      <DialogContent dividers>
        <div style={{ marginBottom: 12, fontSize: 14, color: '#475569' }}>
          {prospect?.name ? <><strong>{prospect.name}</strong> &middot; </> : null}
          {prospect?.mobile}
          <div style={{ marginTop: 6 }}>
            The user will keep their account and can still reach our care team via
            chat / WhatsApp / call. We just mark this request as not pursued.
          </div>
        </div>
        <TextField
          label="Reason (optional)"
          fullWidth
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          margin="dense"
          multiline
          minRows={2}
          autoFocus
        />
        {error ? (
          <div style={{ color: '#b42318', marginTop: 8, fontSize: 13 }}>{error}</div>
        ) : null}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={busy}>Cancel</Button>
        <Button onClick={handleSubmit} variant="contained" color="error" disabled={busy}>
          {busy ? 'Closing…' : 'Close request'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
